// Existing route inventory for tenant-owner admission and static/detail precedence.
// Keep in sync when adding routes; unknown paths fail closed.
export const REGISTERED_APP_ROUTES = [
  // Profile workflows mounted during the September 2026 round.
  "/raw-materials", // 2026-09-21 (Manak): raw materials + approval
  "/approvals/order-changes", // 2026-09-28: confirmed sales order edit/delete requests
  "/serials/numbering", // 2026-10-04: SR hand-off serial numbering
  "/serials/seeding", // 2026-10-04: SR hand-off serial numbering
  "/serials/labels", // 2026-10-04: SR hand-off serial numbering
  "/serials/frame-station", // 2026-10-04: SR hand-off serial numbering
  "/serials/po-ranges", // 2026-10-04: SR hand-off serial numbering
  "/serials/boxes", // 2026-10-04: SR hand-off serial numbering
  "/hr/mobile-apps", // 2026-10-07: Apps & Training — HR + admin
  "/hr/app-tour-progress", // 2026-10-07: Apps & Training — HR + admin
  "/hr/recruitment/partners", // 2026-10-08: recruitment channels — local partners
  "/warehouse/putaway",
  "/warehouse/issue",
  "/gate",
  "/gate/queue",
  "/gate/scan-in",
  "/gate/scan-out",
  "/gate/log",
  "/gate/entry", // 2026-10-04 Gate Entry — guard station
  "/warehouse/gate-entries", // 2026-10-04 Gate Entry — register / day-book / exceptions
  "/loading",
  "/loads",
  "/loading/scan",
  "/loading/photos",
  "/loading/damage",
  "/dispatch/shortages",
  "/dispatch/account-status",
  "/dispatch/loading",
  "/quality",
  "/quality/disposition",
  "/quality/release",
  "/quality/count-approvals",
  "/quality/escalations",
  "/inspect",
  "/inspect/queue",
  "/inspect/readings",
  "/inspect/scan",
  "/inspect/escalations",
  "/my-shift",
  "/my-shift/tasks",
  "/my-shift/machine-check",
  "/my-shift/readings",
  "/my-shift/checklist",
  "/my-shift/photos",
  "/my-shift/move",
  "/my-shift/problem",
  "/manufacturing/shortages",
  "/service/my-day",
  "/service/my-tickets",
  "/service/parts",
  "/service/installations",
  "/service/installations/:id",
  "/warranty-lookup",
  "/no-access",
  '/crm/callbacks', '/crm/data-quality', '/dispatch-status',
  "/my-outstanding",
  "/follow-ups",
  "/quick-quote",
  "/admin/roles",
  "/dispatch/shipments",
  "/dispatch/shipments/:id",
  "/login",
  "/forgot-password",
  "/reset-password",
  "/logout",
  "/",
  "/dashboard",
  "/reports",
  "/customers",
  "/contacts",
  "/contacts/:id",
  "/accounts",
  "/accounts/:id",
  "/deals",
  "/deals/:id",
  "/proposals",
  "/proposals/new",
  "/proposals/:id/edit",
  "/discount-requests",
  "/admin/access-requests",
  "/mockupboard", // 2026-10-10: Mockup Board — owner/admin/super_admin
  "/dealer-leads",
  "/dealer-management",
  "/dealer-prospects", // 2026-09-24 — Prospect dealers
  "/dealer-coverage",
  "/meetings",
  "/admin/call-recordings",
  "/admin/team-performance",
  "/admin/employee-report",
  "/admin/sales-targets",
  "/admin/call-kpi",
  "/admin/system-health",
  "/team-tracking",
  "/attendance-admin",
  "/estimates",
  "/estimates/new",
  "/estimates/:id/edit",
  "/sales-orders",
  "/sales-orders/new",
  "/sales-orders/:id",
  "/sales-orders/:id/edit",
  "/sales-orders/:id/fulfil",
  "/invoices",
  "/invoices/new",
  "/invoices/:id",
  "/invoices/:id/edit",
  "/payments",
  "/credit-notes",
  "/debit-notes",
  "/accounting",
  "/accounting/ledger",
  "/accounting/legacy",
  "/payment-confirmations",
  "/accounting/suite/reports",
  "/accounting/suite/payments",
  "/accounting/suite/period",
  "/gst/e-invoices",
  "/gst/e-waybills",
  "/gst/filing",
  "/gst/gstr2b",
  "/gst/gstr9",
  "/finance/gst-filing",
  "/purchase-invoices",
  "/purchase-invoices/new",
  "/purchase-invoices/:id",
  "/ledger/vouchers",
  "/ledger/vouchers/:id",
  "/ledger/accounts/:accountId",
  "/ledger/trial-balance",
  "/ledger/profit-loss",
  "/ledger/balance-sheet",
  "/coupons/new",
  "/coupons/:id/edit",
  "/projects",
  "/projects/:id",
  "/tasks",
  "/calendar",
  "/warehouse/dashboard",
  "/warehouse/inward",
  "/warehouse/grn",
  "/job-work",
  "/job-work/ledger",
  "/warehouse/dispatch-dashboard",
  "/products",
  "/product-catalogue",
  "/product-settings",
  "/inventory",
  "/warehouse/inventory-pipeline",
  "/production",
  "/warehouse/stock-audit",
  "/warehouse/transfers",
  "/warehouse/barcode-print",
  "/warehouse/dispatch-register",
  "/warehouse/receiving-register",
  "/warehouse/gate-passes",
  "/warehouse/barcode-onboarding",
  "/customer-returns",
  "/returns",
  "/manufacturing/packing/ss-tank/:id",
  "/manufacturing/packing/solar-wh/:id",
  "/manufacturing/packing/heat-pump/:id",
  "/warehouse-locations",
  "/material-boxes",
  "/purchase-dashboard",
  "/vendor-rate-comparison",
  "/vendor-returns",
  "/vendor-returns/:id",
  "/purchase-requests",
  "/purchase-requests/:id",
  "/vendors",
  "/purchase-orders",
  "/purchase-orders/new",
  "/purchase-orders/:id/edit",
  "/samples",
  "/procurement/landed-cost",
  "/finance/invoice-swap",
  "/finance/approvals",
  "/finance/dispatch-approvals",
  "/finance/security-deposits",
  "/deal-closure",
  "/integrations/tally-sync",
  "/tally-export",
  "/veda-agro/samples",
  "/veda-agro/landed-cost",
  "/veda-agro/invoice-swap",
  "/veda-agro/financial-approvals",
  "/veda-agro/security-payments",
  "/veda-agro/deal-closure",
  "/veda-agro/tally-sync",
  "/veda-agro/leads",
  "/veda-agro/deals",
  "/veda-agro/po-create",
  "/veda-agro/supplier-quotes",
  "/veda-agro/truck-tracking",
  "/veda-agro/payments",
  "/veda-agro/advances",
  "/veda-agro/invoice-upload",
  "/veda-agro/margin-report",
  "/quotation-jobs",
  "/quotation-jobs/:id",
  "/transport-partners",
  "/shipments",
  "/dispatch",
  "/shipments/:id",
  "/logistics/rate-comparison",
  "/logistics/flow",
  "/payment-gate",
  "/logistics/pipeline",
  "/logistics/tracker",
  "/logistics/templates",
  "/dispatch-config",
  "/dispatch-config/from-so/:salesOrderId",
  "/dispatch-forms/new/:salesOrderId",
  "/dispatch-forms",
  "/dispatch-forms/:id",
  "/dispatch-config/slip/:id",
  "/warehouse/cash-rewards",
  "/field-partners",
  "/field-partners/kyc-review",
  "/field-partners/claims",
  "/field-partners/incentive-rules",
  "/field-partners/payouts",
  "/field-partners/fraud-review",
  "/field-partners/config",
  "/purchase-contracts",
  "/transport-contracts",
  "/manufacturing/boms",
  "/boms/new",
  "/boms/:id/edit",
  "/manufacturing/orders/new",
  "/production-orders/:id",
  "/manufacturing/orders/:id",
  "/manufacturing/production-orders/:id",
  "/qc-templates",
  "/manufacturing/instruments",
  "/rejections",
  "/manufacturing/dashboard",
  "/manufacturing/shop-floor",
  "/manufacturing/planning",
  "/production/plan",
  "/production-planning",
  "/manufacturing/shift-control",
  "/manufacturing/rm-inspection",
  "/manufacturing/process-kanban",
  "/manufacturing/qc",
  "/manufacturing/lot-approvals",
  "/manufacturing/dispatch",
  "/manufacturing/alerts",
  "/manufacturing/pipeline",
  "/manufacturing/shift-report",
  "/manufacturing/barcodes",
  "/manufacturing/scrap",
  "/manufacturing/pipeline-config",
  "/manufacturing/floor-inspection",
  "/warehouse/barcode-lifecycle",
  "/warehouse/product-units",
  "/escalation-rules",
  "/leads",
  "/field-activity",
  "/field-sessions",
  "/field-agents",
  "/field-agents/:userId",
  "/admin/field-ta-da-rates",
  "/finance/tada-claims",
  "/lead-activity",
  "/leads/triage",
  "/leads/dashboard",
  "/leads/:id",
  "/so-po-mapping",
  "/sales-orders/:soId/margins",
  "/sales-orders/:soId/financial-approval",
  "/service/sop-dashboard",
  "/service/complaints/:id",
  "/service/itbp-installations",
  "/service/itbp-installations/:id",
  "/service/itbp-reports",
  "/service-tickets",
  "/service-tickets/new",
  "/service-tickets/:id",
  "/service-tickets/:id/components",
  "/service-tickets/:id/photos",
  "/service-tickets/:id/audit",
  "/service-tickets/:id/otp",
  "/inventory/units/:code/history",
  "/support/my",
  "/support/tickets",
  "/support/tickets/:id",
  "/support/bug-tests",
  "/support/bug-tests/:id",
  "/products/:id/docs",
  "/service/intake",
  "/service/warranty-verify/:id",
  "/service/pre-visit/:id",
  "/service/diagnosis/:id",
  "/service/on-site/:id",
  "/service/warranty-claim/:id",
  "/warranties",
  "/employees",
  "/payroll",
  "/expense-approvals",
  "/leave-requests",
  "/incentives",
  "/hr/recruitment",
  "/workflows",
  "/analytics",
  "/ai",
  "/ai/agents",
  "/ai/integrations",
  "/credits",
  "/proposal-builder",
  "/knowledge-base",
  "/admin",
  "/admin/tenants",
  "/admin/billing",
  "/admin/health",
  "/admin/team",
  "/admin/audit-logs",
  "/admin/resources",
  "/admin/lead-approvals",
  "/admin/settings",
  "/admin/permissions",
  "/admin/follow-ups",
  "/admin/announcements",
  "/admin/carrier-numbers",
  "/admin/installations",
  "/admin/proposal-builder",
  "/admin/product-specs",
  "/admin/lead-router",
  "/admin/lead-router/dealers",
  "/admin/lead-routing",
  "/admin/calculator-builder",
  "/admin/analytics",
  "/admin/discount-policies",
  "/sales/meeting/start",
  "/sales/meeting/calculators",
  "/sales/meeting/calculator",
  "/sales/meeting/calculator/pool",
  "/sales/meeting/calculator/commercial-heat-pump",
  "/sales/meeting/calculator/ss-tank",
  "/sales/meeting/calculator/customized-tank",
  "/sales/meeting/calculator/domestic-heat-pump",
  "/admin/pool-models",
  "/admin/commercial-heat-pump-models",
  "/admin/ss-tank-models",
  "/admin/domestic-heat-pump-models",
  "/telecaller",
  "/telecaller/call/:callId",
  "/call-logs",
  "/calls",
  "/calls/lead/:leadId",
  "/offers",
  "/team-performance",
  "/sales/activities",
  "/sales/reps",
  "/executive/sales/call-queue",
  "/executive/sales/deals",
  "/executive/sales/incentives",
  "/executive/sales/history",
  "/executive/service/tickets",
  "/executive/service/parts-expenses",
  "/executive/production/work-orders",
  "/executive/production/qc-checkpoints",
  "/executive/warehouse/grn",
  "/executive/warehouse/dispatch",
  "/executive/accounts/match-queue",
  "/executive/accounts/approvals",
  "/executive/field-partner/claims",
  "/executive/field-partner/payouts",
  "/profile",
  "/account",
  "/settings/ai-assistant",
  "/settings",
  "/billing/plans",
  "/lead-manager",
  "/lead-manager/unverified",
  "/lead-manager/verify/:id",
  "/lead-manager/verified",
  "/lead-manager/assigned",
  "/lead-manager/reassignments",
  "/lead-manager/metrics",
  "/lead-manager/search",
  "/lead-manager/leads/:id",
  "/lead-manager/settings",
  "/warehouse",
  "/warehouse/inventory",
  "/service",
  "/service/tickets",
  "/tickets",
  "/scorecard",
  "/scorecard/team",
  "/scorecard/org",
  "/pipeline",
  "/lead-ops",
  "/sales-targets",
  // 2026-10-02 App Tour (sales team lessons).
  "/tour",
  "/tour/:lessonId"
] as const;
